/** @format */

export const END_POINT = {
  AUTH: {
    LOGIN: "/login",
    LOGOUT: "/logout",
    ME: "/me",
    REFRESH_TOKEN: "/refresh",
  },
  ACTIVITIES: {
    LIST: "/activities",
  },
  MEMBERS: {
    LIST: "/users",
    SEARCH: "/users/search",
  },
  PROJECTS: {
    LIST: "/projects",
  },
  TAGS: {
    LIST: "/tags",
  },
  TASKS: {
    LIST: "/tasks",
    SEARCH: "/search",
  },
  ACCOUNT_CODES: {
    LIST: "/account-codes",
  },
  PAYMENT_VOUCHERS: {
    LIST: "/payment-vouchers",
  },
  PAYMENT_BANKINGS: {
    LIST: "/payment-bankings",
  },
  OPENING_BALANCE: {
    LIST: "/opening-balance",
  },
  BANK_ACCOUNTS: {
    LIST: "/bank-accounts",
  },
  COMPANIES: {
    LIST: "/companies",
  },
  RECEIPT_BANKINGS: {
    LIST: "/receipt-bankings",
  },
  CUSTOMERS: {
    LIST: "/customers",
  },
  DEPARTMENTS: {
    LIST: "/departments",
  },
  EMPLOYEES: {
    LIST: "/employees",
  },
  INVENTORIES: {
    LIST: "/inventories",
  },
  RECEIPTS: {
    LIST: "/receipts",
  },
  PURCHASE_ORDERS: {
    LIST: "/purchase-orders",
  },
  SALE_ORDERS: {
    LIST: "/sale-orders",
  },
  OTHER_ORDERS: {
    LIST: "/other-oders",
  },
  RETURN_ORDERS: {
    LIST: "/return-orders",
  },
  WMS_CODES: {
    LIST: "/wms-codes",
  },
  WMS_ITEM_GROUPS: {
    LIST: "/wms-item-groups",
  },
  WMS_ITEMS: {
    LIST: "/wms-items",
  },
};

export const headersFormData = {
  Accept: "application/json",
  'Content-Type': 'multipart/form-data',
}
